import { IntlKey } from 'locales';
import { CurrencyListFieldMetadata } from 'models/forms/fields';

export function toCurrency(
  value: unknown,
  fieldMetadata: CurrencyListFieldMetadata,
  translationMap: Partial<Record<IntlKey, string>>,
): string | undefined {
  if (typeof value !== 'string') {
    return undefined;
  }
  const matchedItem = fieldMetadata.availableItems.find(item => getTranslatedValue(item, translationMap) === value);
  return matchedItem?.value ?? undefined;
}

function getTranslatedValue(
  item: { translationKey?: string; value: string; label: string },
  translationMap: Partial<Record<IntlKey, string>>,
): string {
  const translationKey = `form.${item.translationKey}` as IntlKey;
  return translationMap[translationKey] ?? translationMap[item.value as IntlKey] ?? item.label;
}
